import * as React from 'react'
import IconBase from './IconBase'

const RentalIcon = () => (
  <IconBase path="M9,16 L15,16 L15,10 L19,10 L12,3 L5,10 L9,10 L9,16 Z M5,18 L19,18 L19,20 L5,20 L5,18 Z" />
)

export default RentalIcon
